import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsDigitalPromptServiceService } from 'src/app/patient-center/utils.service';
import { ClientDigitalPromptServiceConfigService } from 'src/app/shared/services/API/digital-prompt-service/client-digital-prompt-service-config.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks } from 'src/app/shared/services/mask.service';
import { UserPatient } from 'src/app/shared/services/models/patient-center/user-patient.model';
import { PatientAppointment } from 'src/app/shared/services/models/schedule/patient-appointment.model';
import { DigitalPromptConfigStruct } from 'src/app/shared/services/structs/digital-prompt-service/digital-prompt-service-config.struct';
import { PatientAppointmentStruct } from 'src/app/shared/services/structs/orchestrator-schedule/patient-appointment.struct';
import { NatureOfAttendanceEnum } from 'src/app/shared/enum/medical-record/nature-of-attendance.enum';
import { PatientCenterAppointmentService } from 'src/app/shared/services/API/orchestrator-schedule/orchestratort-patient-appointment.service';
import { MedicalSpecialtyStruct } from 'src/app/shared/services/structs/digital-prompt-service/medical-specialty.struct';
import { MedicalSpecialtyPatientCenterService } from 'src/app/shared/services/API/digital-prompt-service/medical-specialty-patient-center.service';
import { PaginatedPatientAppointmentRequest } from 'src/app/shared/services/requests/schedule/paginated-patient-appointment.request';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppointmentDetailsModalComponent } from '../appointment-details-modal/appointment-details-modal.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-patient-appointment-history',
  templateUrl: './patient-appointment-history.component.html',
  styleUrls: ['./patient-appointment-history.component.css']
})
export class PatientAppointmentHistoryComponent implements OnInit {
  constructor(
    private patientAppointmentOrchService: PatientCenterAppointmentService,
    private alertService: AlertService,
    public router: Router,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private clientDigitalPromptServiceConfigService: ClientDigitalPromptServiceConfigService,
    private utilsDigitalPromptServiceService: UtilsDigitalPromptServiceService,
    private medicalSpecialtyPatientCenterService: MedicalSpecialtyPatientCenterService,
  ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  public masks: Masks;
  public model: FormGroup;
  public isLoading: boolean = false;
  public uri: string;
  public colorCode: string = '#99C8D6';
  public digitalPromptServiceConfig: DigitalPromptConfigStruct;
  public listPastPatientAppointment: PatientAppointmentStruct[] = [];
  public listMedicalSpecialty: MedicalSpecialtyStruct[] = [];
  public patient: UserPatient;
  public standardAttendance: number = NatureOfAttendanceEnum.presencial;
  public onlineAttendance: number = NatureOfAttendanceEnum.online;

  public pageIndex: number = 0;
  public pageSize: number = 10;
  public fullListSize: number;

  ngOnInit(): void {

    this.model = this.formBuilder.group({
      dateStart: [null],
      dateEnd: [null],
      patientName: [],
      idMedicalSpecialty: [null],
    });

    this.uri = this.activatedRoute.snapshot.paramMap.get('uri');

    this.digitalPromptServiceConfig = this.utilsDigitalPromptServiceService.getDigitalPromptServiceStruct();

    if (this.digitalPromptServiceConfig) {
      if (this.digitalPromptServiceConfig.useColor == true) {
        this.colorCode = this.digitalPromptServiceConfig.colorCode;
        document.documentElement.style.setProperty('--colorCodePatientCenter', this.colorCode);
      }
    }
    else
      this.getConfig(this.uri);

    this.getPatientAppointment();
    this.getAllMedicalSpecialty();
  }

  getConfig(uri: string) {
    this.clientDigitalPromptServiceConfigService.getClientConfig(uri).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          if (response.errorCode != 2)
            return;
        }

        this.digitalPromptServiceConfig = response.digitalPromptConfig;
        this.utilsDigitalPromptServiceService.setDigitalPromptServiceStruct(response.digitalPromptConfig);

        if (response.digitalPromptConfig.useColor) {
          this.colorCode = this.digitalPromptServiceConfig.colorCode;
          document.documentElement.style.setProperty('--colorCodePatientCenter', this.colorCode);
        }
      },
      error: (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  search() {
    this.pageIndex = 0;
    this.getPatientAppointment();
  }

  getPatientAppointment() {

    if (this.isLoading)
      return;

    if (this.model.invalid)
      return this.alertService.show('Erro', 'Preencha todos os campos obrigatórios.', AlertType.error);
    
    this.isLoading = true;
    let valueModel = this.model.getRawValue();
    let request = new PaginatedPatientAppointmentRequest();

    if(valueModel.dateStart) {
      request.dateStart = new Date(Date.UTC(
        valueModel.dateStart.getUTCFullYear(),
        valueModel.dateStart.getUTCMonth(),
        valueModel.dateStart.getUTCDate(),
        0, 0, 1));
    }
    if(valueModel.dateEnd) {
      request.dateEnd = new Date(Date.UTC(
        valueModel.dateEnd.getUTCFullYear(),
        valueModel.dateEnd.getUTCMonth(),
        valueModel.dateEnd.getUTCDate(),
        23, 59, 59));
    }
    
    request.idMedicalSpecialty = valueModel.idMedicalSpecialty;
    request.pageSize = this.pageSize;
    request.pageIndex = this.pageIndex;
    request.takePastAppointments = true;
    
    this.patientAppointmentOrchService.getPatientAppointment(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.listPastPatientAppointment = [];

        let now = new Date();
        this.listPastPatientAppointment = response.listPatientAppointment;
        this.fullListSize = response.fullListSize;

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  changePage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.getPatientAppointment();
  }
  
  getAllMedicalSpecialty() {
    this.isLoading = true;
    this.medicalSpecialtyPatientCenterService.listMedicalSpecialty().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        if (response.listMedicalSpecialty && response.listMedicalSpecialty.length == 0) {
          this.alertService.show('Erro', "Não existem especialidades médicas cadastradas", AlertType.error);
          return;
        }

        this.listMedicalSpecialty = response.listMedicalSpecialty;

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  verifyDateRange() {
    let valueModel = this.model.getRawValue();
    if(valueModel.dateStart || valueModel.dateEnd) {
      this.model.get('dateStart').setValidators([Validators.required]);
      this.model.get('dateEnd').setValidators([Validators.required]);
    } else {
      this.model.get('dateStart').setValidators([]);
      this.model.get('dateEnd').setValidators([]);
    }
    this.model.get('dateStart').updateValueAndValidity();
    this.model.get('dateEnd').updateValueAndValidity();
  }

  cleanFilters() {
    this.model.reset();
    this.verifyDateRange();
    this.getPatientAppointment();
  }

  showDetails(appointment: PatientAppointment) {
    this.dialog.open(AppointmentDetailsModalComponent, {
      data: {
        colorCode: this.colorCode,
        appointment: appointment,
      },
      panelClass: "border-radius-box"
    });
  }

  goBack() {
    this.router.navigate([`patient-center/hub/${this.uri}`])
  }

  verifyDifferenceInMinutes(datetimeStart: Date) {
    let todayDate: Date = new Date();
    let dateStart: Date = new Date(datetimeStart);
    var diff = (dateStart.getTime() - todayDate.getTime()) / 1000;
    diff /= 60;
    return diff;
  }
}